import { render, staticRenderFns } from "./product_nutrition.vue?vue&type=template&id=5410d046&scoped=true&"
import script from "./product_nutrition.vue?vue&type=script&lang=js&"
export * from "./product_nutrition.vue?vue&type=script&lang=js&"
import style0 from "./product_nutrition.vue?vue&type=style&index=0&id=5410d046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410d046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5410d046')) {
      api.createRecord('5410d046', component.options)
    } else {
      api.reload('5410d046', component.options)
    }
    module.hot.accept("./product_nutrition.vue?vue&type=template&id=5410d046&scoped=true&", function () {
      api.rerender('5410d046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_nutrition.vue"
export default component.exports